import React from 'react';
import ProfileList from '../ProfileList/ProfileList';
import JobListings from '../JobListings/JobListings';
import arrowSvg from '../../CreateEventLandingPage/assets/circle-arrow-right-regular.svg';
import { Button } from 'reactstrap';
import Carousel from 'scenes/V2/CreatePostScene/EventIntro/Carousel';

const WelcomeSection = ({ onImReady, institutionsLogoSlides, brandsCarouselRef, brands }) => {
  return (
    <>
      <section id="welcome" className="welcome-section scroll-animate fade-in">
        <div className="layers-wrapper-container scroll-animate slide-right stagger-1">
          <div className="layers-wrapper">
            <ProfileList />
            <JobListings />
          </div>
        </div>

        <div className="content-info">
          <div>
            <h1 className="header scroll-animate fade-up stagger-1">
              <p>The largest job board for athletic trainers</p>
            </h1>
            <div className="advantage scroll-animate slide-left stagger-2">
              <img src={arrowSvg} alt="arrow-1" />
              <p className="subheader">PRN, Long-Term and Travel Opportunities</p>
            </div>
            <div className="advantage scroll-animate slide-left stagger-3">
              <img src={arrowSvg} alt="arrow-2" />
              <p className="subheader">You pick the rates and hours</p>
            </div>
            <div className="advantage scroll-animate slide-left stagger-4">
              <img src={arrowSvg} alt="arrow-3" />
              <p className="subheader">Guaranteed payment</p>
            </div>
          </div>
          <div className="ready-to-apply scroll-animate fade-up stagger-5">
            <Button className="ready-to-apply-button" onClick={onImReady}>
              Get Started
            </Button>
          </div>
        </div>
      </section>

      <div className="brands-container">
        <Carousel
          reference={brandsCarouselRef}
          slides={institutionsLogoSlides()}
          containerClassName="brands"
          viewportClassName="brands"
          emblaClassName="brands"
          options={{
            align: 'start',
            loop: true,
            containScroll: 'trimSnap',
            active: brands.active,
            watchFocus: false,
            watchDrag: false,
          }}
          autoScroll
          autoScrollOptions={{
            playOnInit: true,
            speed: 1.5,
            stopOnInteraction: true,
            stopOnFocusIn: false,
            startDelay: 500,
          }}
        />
      </div>
    </>
  );
};

export default WelcomeSection;
